import { getSvgIcon, Icon } from '@helpers/icons';
import * as React from 'react';
import S from './Button.styles';
const Button = ({ buttonType, children, fillDirection = 'right', icon, iconOnly, iconPosition = 'right', ...otherProps }) => {
    return (React.createElement(S.Container, { "data-fill": fillDirection, "data-icon-only": iconOnly, "data-icon-position": iconPosition, "data-icon-type": icon || buttonType === 'text-only' || buttonType === 'text-only-inverted'
            ? icon ?? Icon.ArrowRight
            : undefined, "data-type": buttonType, ...otherProps },
        React.createElement(S.Text, null, children),
        (icon && icon !== Icon.None) ||
            buttonType === 'text-only' ||
            buttonType === 'text-only-inverted' ? (React.createElement(S.IconWrapper, null, getSvgIcon(icon ?? Icon.ArrowRight))) : null));
};
const FakeButton = ({ buttonType, children, fillDirection = 'right', icon, iconOnly, iconPosition = 'right', ...otherProps }) => {
    return (React.createElement(S.Container, { as: "span", "data-fill": fillDirection, "data-icon-only": iconOnly, "data-icon-position": iconPosition, "data-icon-type": icon || buttonType === 'text-only' || buttonType === 'text-only-inverted'
            ? icon ?? Icon.ArrowRight
            : undefined, "data-type": buttonType, ...otherProps },
        React.createElement(S.Text, null, children),
        (icon && icon !== Icon.None) ||
            buttonType === 'text-only' ||
            buttonType === 'text-only-inverted' ? (React.createElement(S.IconWrapper, null, getSvgIcon(icon ?? Icon.ArrowRight))) : null));
};
const LinkButton = ({ buttonType, children, fillDirection = 'right', icon, iconOnly, iconPosition = 'right', ...otherProps }) => {
    return (React.createElement(S.Container, { as: "a", "data-fill": fillDirection, "data-icon-only": iconOnly, "data-icon-position": iconPosition, "data-icon-type": icon || buttonType === 'text-only' || buttonType === 'text-only-inverted'
            ? icon ?? Icon.ArrowRight
            : undefined, "data-type": buttonType, ...otherProps },
        React.createElement(S.Text, null, children),
        (icon && icon !== Icon.None) ||
            buttonType === 'text-only' ||
            buttonType === 'text-only-inverted' ? (React.createElement(S.IconWrapper, null, getSvgIcon(icon ?? Icon.ArrowRight))) : null));
};
export { Button as default, FakeButton, LinkButton };
